<!--
 * @Description: 新增群活码
 * @Author: yuxin
 * @Date: 2025-08-06 16:18:01
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-09-01 11:39:07
 * @FilePath: \mgr_web\src\views\group\components\addActiveCode.vue
-->
<template>
  <div class="addActiveCode-container">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      :close-on-press-escape="true"
      @close="handleCodeClose"
      v-loading="loading"
    >
      <el-scrollbar style="height: 500px">
        <el-form ref="form" :model="form" label-width="120px" :rules="rules">
          <!-- <el-form-item label="拉群方式：" prop="joinWay">
            <el-select v-model="form.joinWay" placeholder="请选择" size="mini">
              <el-option label="加好友进群" :value="2"></el-option>
              <el-option label="直接进群" :value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="活码名称：" prop="name">
            <el-input
              v-model="form.name"
              size="mini"
              style="width: 195px"
              maxlength="20"
              show-word-limit
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="使用场景：" prop="sceneName">
            <el-input
              v-model="form.sceneName"
              size="mini"
              style="width: 195px"
              maxlength="20"
              show-word-limit
              placeholder="请输入使用场景"
            ></el-input>
          </el-form-item>
          <el-form-item label="扫码标签：" prop="tagList">
            <el-button
              size="mini"
              type="primary"
              @click="addTag"
              icon="el-icon-plus"
            >
              添加标签
            </el-button>
          </el-form-item>
          <el-form-item v-if="form.tagList && form.tagList.length">
            <el-tag
              v-for="(tag, index) in form.tagList"
              :key="index"
              size="mini"
              style="margin: 5px"
            >
              {{ tag.tagName }}
            </el-tag>
          </el-form-item>
          <!-- <el-form-item label="使用员工：" prop="userList">
            <el-button
              size="mini"
              type="primary"
              @click="dialogVisibleTree = true"
            >
              添加员工
            </el-button>
          </el-form-item> -->
          <!-- <el-form-item>
            <el-tag
              v-for="(tag, index) in form.userList"
              :key="index"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
              size="mini"
              style="margin: 5px"
            >
              {{ tag.name }}
            </el-tag>
          </el-form-item> -->
          <!-- <el-form-item label="加群引导语：" prop="welcomeContent">
            <el-input
              type="textarea"
              v-model="form.welcomeContent"
              style="width:420px"
              maxlength="200"
              show-word-limit
              rows="10"
              placeholder="
              请输入入群的欢迎术语
              例如：
              您号，我是xx活动引导员，
              扫描下方二维码，即可参与专享活动！"
            ></el-input>
          </el-form-item> -->
          <div style="margin-top: 20px">
            <el-form-item label="添加群聊：" prop="chatList">
              <el-button
                size="mini"
                type="primary"
                @click="addGroup"
                :disabled="row && row.id ? true : false"
                icon="el-icon-plus"
              >
                选择群聊
              </el-button>
              <div v-if="form.chatList && form.chatList.length">
                已选：
                <el-tag
                  size="mini"
                  style="margin-left: 10px"
                  :closable="row && row.id ? false : true"
                  @close="handleTagDelete(item)"
                  v-for="(item, index) in form.chatList"
                  :key="index"
                  >{{ item.chatName || "--" }}</el-tag
                >
              </div>
              <div class="grop-tip">*单个群人数上限200</div>
            </el-form-item>

            <!-- <div style="display: flex; align-items: center">
              <div style="margin-left: 30px">群人数上限：</div>
              <div style="margin: 0 10px">
                <el-input-number
                  v-model="form.groupLimtNum"
                  size="mini"
                  :controls="false"
                ></el-input-number>
              </div>
              <span style="color: #afafaf">*建议不超过200</span>
            </div> -->
          </div>
          <el-form-item label="自动建群：" prop="autoCreateRoomFlag">
            <el-checkbox
              v-model="form.autoCreateRoomFlag"
              :true-label="1"
              :false-label="0"
              :disabled="row && row.id ? true : false"
              @change="autoCreateRoomFlagChange"
              >开启</el-checkbox
            >
            <span style="color: #afafaf"> *开启后，会在群满后自动建群 </span>
          </el-form-item>
          <el-form-item
            label=" "
            prop="roomBaseName"
            :rules="{
              required: form.autoCreateRoomFlag == 1,
              message: '请输入群名前缀',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="form.roomBaseName"
              size="mini"
              style="width: 195px"
              placeholder="请输入群名前缀"
              :disabled="row && row.id ? true : false"
              maxlength="20"
            />
            <span style="color: #afafaf">
              *系统会按照前缀为新建的群依次命名
            </span>
          </el-form-item>
          <el-form-item
            label=" "
            prop="roomBaseId"
            :rules="{
              required: form.autoCreateRoomFlag == 1,
              message: '请输入起始序号',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="form.roomBaseId"
              size="mini"
              style="width: 195px"
              placeholder="请输入起始序号"
              @input="numberInput('roomBaseId')"
              :disabled="row && row.id ? true : false"
              maxlength="8"
            />
            <span style="color: #afafaf">
              *新建的第一个群起始序号，后面会依次+1
            </span>
          </el-form-item>
          <el-form-item label="有效期至：" prop="expireTime">
            <el-date-picker
              v-model="form.expireTime"
              value-format="timestamp"
              type="date"
              placeholder="选择日期"
              size="mini"
              :picker-options="expirationTimePickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <div style="text-align: right">
        <el-button size="mini" @click="cancel">取消</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="handleSubmit"
          :loading="btnLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <AddTags
      ref="AddTagsRef"
      v-if="addTagsShow"
      @getSelectedTage="getSelectedTage"
      @closeTageDia="closeTageDia"
    />

    <AddGroup
      ref="AddGroupRef"
      v-if="addGroupShow"
      @getSelectedGroup="getSelectedGroup"
      @closeGroupDia="closeGroupDia"
    />
    <el-dialog
      title="添加标签"
      :visible.sync="tagVisible"
      :close-on-click-modal="false"
      width="30%"
      close-on-press-escape
      v-if="tagVisible"
    >
      <el-select
        v-model="uid"
        placeholder="请选择"
        size="small"
        style="width: 100%"
      >
        <el-option
          v-for="item in tagList"
          :key="item.groupId"
          :label="item.groupName"
          :value="item.groupId"
        />
      </el-select>
      <div style="margin: 30px 0">
        <el-checkbox-group v-model="checkList">
          <template v-for="(i, index) in tagItemList">
            <el-checkbox :label="i.tagId">{{ i.tagName }}</el-checkbox>
          </template>
        </el-checkbox-group>
      </div>
      <div style="text-align: right">
        <el-button type="primary" size="mini" @click="handleTags"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- <StaffTree
      title="选择使用成员"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree> -->
  </div>
</template>
<script>
import AddTags from "./addTags";
import AddGroup from "./addGroup";
import dayjs from "dayjs";
// import StaffTree from "@/components/staffTree/staffTree.vue";
import {
  groupCodeAddApi,
  getGroupCodeDetailApi,
  updateGroupCodelApi,
} from "@/api/group/code.js";
export default {
  components: {
    AddTags,
    AddGroup,
    // StaffTree,
  },
  props: {},
  data() {
    return {
      /** dialog标题 */
      title: "新建活码",
      /** 控制弹窗显示隐藏 */
      dialogVisible: false,
      /** 搜索菜单名称 */
      searchMenNames: [],
      /** 表单数据 */
      form: {
        /** 	进群方式 1 - 直接进群 2 - 好友进群 */
        // joinWay: 2,
        /** 活码名称 */
        name: "",
        /** 使用场景 */
        sceneName: "",
        /** 添加标签 */
        tagList: [],
        /** 添加员工 */
        // userList: [],
        /** 加群引导语 */
        // welcomeContent: "",
        /** 指定群对象 */
        chatList: [],
        /** 当群满了后，是否自动新建群。0-否；1-是。 默认为1 */
        autoCreateRoomFlag: 1,
        /** 自动建群的群名前缀，当auto_create_room为1时有效。 */
        roomBaseName: "",
        /** 自动建群的群起始序号，当auto_create_room_flag为1时有效 */
        roomBaseId: "",
        /** 有效期截至时间 */
        expireTime: "",

        /** 是否加好友进群 */
        // qrType: "0",
        /** 活码名称 */
        // qrName: "",
        /** 场景名称 */
        // sceneName: "",
        /** 标签id 多个标签用逗号隔开 */
        tagId: "",
        /** 标签名称 多个标签用逗号隔开 */
        tagName: "",
        /** 使用者ID 多个用逗号隔开 */
        userIdList: "",
        /** 使用者姓名 */
        userNameList: "",
        /** 树形ID */
        treeIdList: "",
        /** 群id 多个群用逗号隔开 */
        chatIdList: "",
        /** 群名称 多个群名用逗号隔开 */
        groupNames: "",
        /** 引导语 */
        // welcomeContent: "",
        welcomeId: "1",
        sceneId: "2",
        /** 群人数上限 */
        groupLimtNum: 0,
        /** 有效期 */
        expirationTime: "",
        /** 人满是否新建活码 */
        autoCreateRoomFlag: 0,
        /** 新建群前缀 */
        roomBaseName: "",
        /** 新建群开始序号 */
        roomBaseId: "",
        /** 存储标签列表 */
        // tagList: [],
        /** 选中的标签 */
        checkList: [],
        /** 组标签数据 */
        tagItemList: [],
        /** 存储名称数组 */
        nameList: [],
        uid: [],
      },
      /** 控制标签显示隐藏 */
      tagVisible: false,
      /** 组件中要显示-选中的成员 */
      currentSelectMember: [],
      /** 控制添加标签弹窗显示隐藏 */
      addTagsShow: false,
      /** 控制添加群聊弹窗显示隐藏 */
      addGroupShow: false,
      /** 控制员工弹窗显示隐藏 */
      dialogVisibleTree: false,
      /** 校验规则 */
      rules: {
        // joinWay: [
        //   { required: true, message: "请选择拉群方式", trigger: "change" },
        // ],
        name: [{ required: true, message: "请输入活码名称", trigger: "blur" }],
        sceneName: [
          { required: true, message: "请输入使用场景", trigger: "blur" },
        ],
        // tagList: [
        //   { required: true, message: "请选择扫码标签", trigger: "change" },
        // ],
        // userList: [
        //   { required: true, message: "请选择使用员工", trigger: "change" },
        // ],
        // welcomeContent: [
        //   { required: true, message: "请输加群引导语", trigger: "blur" },
        // ],
        chatList: [
          { required: true, message: "请选择群聊", trigger: "change" },
        ],
        autoCreateRoomFlag: [
          { required: true, message: "请勾选是否自动建群", trigger: "blur" },
        ],
        // roomBaseName: [
        //   { required: true, message: "请输入群名前缀", trigger: "blur" },
        // ],
        // roomBaseId: [
        //   { required: true, message: "请输入起始序号", trigger: "blur" },
        // ],
        expireTime: [
          { required: true, message: "请输入有效期", trigger: "change" },
        ],
      },
      /** 弹窗加载 */
      loading: false,
      /** 按钮加载 防止重复提交*/
      btnLoading: false,
      /** 禁止选中过去时间 */
      expirationTimePickerOptions: {
        disabledDate(time) {
          // 禁用今天之前的所有日期（不含今天）
          return time.getTime() < Date.now() - 8.64e7; // 8.64e7 = 24小时毫秒数
        },
      },
      /** 存储编辑数据 */
      row: null,
    };
  },
  methods: {
    /** 初始化组件 */
    init(data) {
      this.dialogVisible = true;
      if (data) {
        this.row = data;
        this.title = "编辑";
        this.getDetail();
      }
    },

    /** 获取活码详情 */
    getDetail() {
      this.loading = true;
      getGroupCodeDetailApi(
        { id: this.row.id },
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res && res.error && res.error.code == 200) {
          console.log("res+++++", res);
          for (const key in res.data) {
            if (key in this.form) {
              this.form[key] = res.data[key];
            }
          }
        }
        this.loading = false;
      });
    },

    /** 时间变化触发 */
    // expireTimeChange(val){
    //     if (this.form.expireTime != null) {
    //     this.form.expireTime = dayjs(this.form.expireTime).format(
    //       "YYYY-MM-DD HH:mm:ss"
    //     );
    //     console.log("dfsdfsdfsd", this.form.expireTime );
    //   }else {
    //     this.form.expireTime = ""
    //   }
    // },

    /** 点击取消触发 */
    cancel() {
      this.dialogVisible = false;
    },

    /** 点击添加标签按钮触发 */
    addTag() {
      this.addTagsShow = true;
      this.$nextTick(() => {
        this.$refs.AddTagsRef.init(this.form.tagList);
      });
    },

    /** 获取选中标签 */
    getSelectedTage(e) {
      // this.addTagsShow = false;
      this.form.tagList = e;
      //  this.$refs.form.clearValidate("tagList")
    },
    /** 选择标签弹窗关闭触发 */
    closeTageDia() {
      this.addTagsShow = false;
    },

    /** 获取选中群聊数据 */
    getSelectedGroup(e) {
      // this.addTagsShow = false;
      this.form.chatList = e;
      this.$refs.form.clearValidate("chatList");
    },

    /** 选择群聊弹窗关闭触发 */
    closeGroupDia() {
      this.addGroupShow = false;
    },

    /** 新增群触发 */
    addGroup() {
      this.addGroupShow = true;
      this.$nextTick(() => {
        this.$refs.AddGroupRef.init(this.form.chatList);
      });
    },

    /** 关闭弹窗触发 */
    handleCodeClose(isRefresh) {
      this.dialogVisible = false;
      this.$emit("addAndEditClose", isRefresh);
    },

    /** 开启复选框状态变化 */
    autoCreateRoomFlagChange(val) {
      console.log("val+++", val);
      if (val == 0) {
        this.$refs.form.clearValidate(["roomBaseName", "roomBaseId"]);
      }
    },

    /** 点击确认触发 */
    handleSubmit() {
      console.log("Sdfsfsdfsd", this.form);
      this.$refs["form"].validate((valid, fields) => {
        if (valid) {
          this.btnLoading = true;
          const requestParams = {
            id: "",
            name: "",
            // joinWay: "",
            autoCreateRoomFlag: false,
            roomBaseName: "",
            roomBaseId: "",
            sceneName: "",
            // welcomeContent: "",
            expireTime: "",
            // userList: [],
            tagList: [],
            chatList: [],
          };
          for (const key in this.form) {
            if (key in requestParams) {
              // if (key != "userList") {
              requestParams[key] = this.form[key];
              // }
              // else {
              //   this.form.userList.forEach((item) => {
              //     requestParams.userList.push({
              //       corpUserId: item.userId,
              //       name: item.name,
              //     });
              //   });
              // }
            }
          }
          /** 后端要求时间日期必须加上时间23:59:59,这里对时间进行处理 */
          const date = new Date(requestParams.expireTime);
          date.setHours(23, 59, 59, 999);
          requestParams.expireTime = date.getTime();
          console.log("this.form.expireTime+++", requestParams.expireTime);
          if (this.row && this.row.id) {
            /** 编辑走这里 */
            requestParams.id = this.row.id;
            updateGroupCodelApi(
              requestParams,
              localStorage.getItem("Authorization")
            ).then((res) => {
              if (res && res.error && res.error.code == 200) {
                this.$message.success("操作成功");
                this.handleCodeClose(true);
                this.btnLoading = false;
              }
            });
          } else {
            /** 新增走这里 */
            groupCodeAddApi(
              requestParams,
              localStorage.getItem("Authorization")
            ).then((res) => {
              if (res && res.error && res.error.code == 200) {
                this.$message.success("操作成功");
                this.handleCodeClose(true);
                this.btnLoading = false;
              }
            });
          }
        } else {
          /** 当校验不通用时，滚动第一项未通过的位置 */
          const errDom = this.$refs.form.$el.querySelectorAll(
            ".el-form-item__error"
          )[0] || { scrollIntoView: () => {} };
          errDom.scrollIntoView({ block: "center" });
        }
      });
    },

    /** 处理标签 */
    handleTags() {
      this.form.tagList = this.tagChildList.filter((item) => {
        if (this.checkList.includes(item.tagId)) {
          return item.tagName;
        }
      });
      console.log("this.tagList", this.form.tagList);
      this.tagVisible = false;
    },

    /** 删除选中群 */
    handleTagDelete(tag) {
      this.form.chatList.forEach((item, index) => {
        if (item.chatId == tag.chatId) {
          this.form.chatList.splice(index, 1);
        }
      });
    },

    /** 关闭人员树触发 */
    closeTree(val) {
      this.dialogVisibleTree = false;
    },

    /** 只能输入非负数 */
    numberInput(key) {
      /** 空值不做操作 */
      if (!this.form[key]) return;
      /** 是数字就转为字符串，替换 */
      if (
        Object.prototype.toString.call(parseInt(this.form[key])) ===
          "[object Number]" &&
        isNaN(parseInt(this.form[key]))
      ) {
        console.log("有没有进来");

        return (this.form[key] = String(this.form[key]).replace(/\D/g, ""));
      }

      /** 不是数字需要转换 */
      if (String(this.form[key]).replace(/\D/g, "")) {
        this.form[key] = parseInt(String(this.form[key]).replace(/\D/g, ""));
      } else {
        this.form[key] = "";
      }
    },
  },
  watch: {
    uid: {
      handler(newVal) {
        this.tagItemList =
          this.form.tagList.filter((item) => item.groupId == newVal).length > 0
            ? this.form.tagList.filter((item) => item.groupId == newVal)[0][
                "hmcActivityTagList"
              ]
            : [];
      },
    },
  },
  /** 生命周期 */
  created() {},
};
</script>
<style lang="scss" scoped>
.addActiveCode-container {
  .grop-tip {
    color: #ccc;
  }
}
</style>
